import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as StyletronProvider } from 'styletron-react';
import { Client as Styletron } from 'styletron-engine-atomic';
import { BaseProvider } from 'baseui';
import App from './App';
import './fonts.scss';
import theme from './theme';

const engine = new Styletron();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root container missing in index.html');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <StyletronProvider value={engine}>
      <BaseProvider theme={theme}>
        <App />
      </BaseProvider>
    </StyletronProvider>
  </React.StrictMode>,
);
